import { getBalanceLabel, getCountryNameByCode } from 'services/utils/helper';
import { DateTimezone } from 'components/common';
import { isNil } from 'lodash';

import voice from 'assets/images/try-it/voice.svg';
import rcs from 'assets/images/try-it/rcs.svg';
import viber from 'assets/images/try-it/viber.svg';
import whatsapp from 'assets/images/try-it/whatsapp.svg';
import telegram from 'assets/images/try-it/telegram.svg';
import sms from 'assets/images/try-it/sms.svg';
import defaultDexatel from 'assets/images/try-it/dexatel.svg';
import React from 'react';

export const CurrencyRenderer = (value: any, currency: any) => {
    if (isNil(value) || isNaN(parseFloat(value))) {
        return getBalanceLabel('0', currency);
    }
    return getBalanceLabel(value, currency);
};

export const DateRenderer = (value: string) => {
    if (isNil(value)) {
        return <></>;
    }
    return <DateTimezone value={value} />;
};

export const CountryRenderer = (value: string, item: any = {}) => {
    if (item.withCompany && typeof item.id === 'undefined') {
        return item.company_name;
    }
    return getCountryNameByCode(value.toLowerCase());
};

export const PeriodRenderer = (value: string, item: any) => {
    return (
        <span>
            <DateTimezone value={item.period_start} /> - <DateTimezone value={item.period_end} />
        </span>
    );
};

const ChannelAppearance: Record<string, string> = {
    VIBER: viber,
    WHATSAPP: whatsapp,
    SMS: sms,
    VOICE: voice,
    G_RCS: rcs,
    TELEGRAM: telegram,
    DEFAULT: defaultDexatel,
};

export const CHANNELS_MAP: any = {
    VIBER: 'Viber',
    WHATSAPP: 'WhatsApp',
    SMS: 'SMS',
    VOICE: 'Voice',
    G_RCS: 'Google RCS',
    TELEGRAM: 'Telegram',
    DEFAULT: 'All Channels',
};

export const ChannelRenderer = (channelLower: string, voiceType: string) => {
    const channel = channelLower.toUpperCase();
    let text = CHANNELS_MAP[channel];
    if (channel === 'VOICE' && voiceType) {
        text += ` (${voiceType})`;
    }

    return (
        <div className="d-flex gap-1 align-items-center">
            {ChannelAppearance[channel] && (
                <img src={ChannelAppearance[channel]} alt={channel} width={24} height={24} />
            )}
            {text}
        </div>
    );
};

const renderers = { CurrencyRenderer, DateRenderer, CountryRenderer, ChannelRenderer };

export default renderers;
